'use strict'

import api from '../../api/auth'

const app = new Vue({
  i18n,
	el: '#authLogin',
	data: () => ({
    username: '',
    password: '',
    securityCode: '',
    isSubmitting: false
  }),
  async beforeCreate () {
    try {
      const response = await api.checkCurrentUser()
      const ingroup = _.get(response.data, 'user.ingroup')
      location.href = `/${ingroup}`
      return
    } catch (error) {
      $('#auth-login').removeClass('d-none')
    }
  },
	mounted () {
		setTimeout(() => {
			this.focus()
    }, 10)
  },
	methods: {
		focus () {
			$('#inputUsername').focus()
    },
		onSubmit (e) {

			this.$validator.validateAll().then((result) => {
				if(result) {
					this.isSubmitting = true
					e.preventDefault()

					const data = {
						username: this.username,
						password: this.password,
						securityCode: this.securityCode,
          }

          api.login(data,
            (response) => {
              console.log(response)
              this.isSubmitting = false
              const data = _.get(response.data, 'data')
              window.Cookies.set('utoken', JSON.stringify(data), {
                expires: 7,
                path: '/'
              })
              location.href = `/${data.role}`
            },
            (error) => {
              this.isSubmitting = false
              this.alertErrorMessage(error, '#authLogin')
              // return
            }
          )
				}
			})
		}
	}
})
